// extracted by mini-css-extract-plugin
export var dividerContainer = "_9n-0";
export var line = "_9n-1";